import { render, staticRenderFns } from "./TopbarLinkGroup.vue?vue&type=template&id=570d0d9a&"
import script from "./TopbarLinkGroup.vue?vue&type=script&lang=js&"
export * from "./TopbarLinkGroup.vue?vue&type=script&lang=js&"
import style0 from "./TopbarLinkGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports